import { render, staticRenderFns } from "./SubLocations.vue?vue&type=template&id=a19043b6&"
import script from "./SubLocations.vue?vue&type=script&lang=js&"
export * from "./SubLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports